namespace TabAurous.Inventory {
    export interface MaterialReceiptForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: MaterialReceiptItemsEditor;
        Remark: Serenity.TextAreaEditor;
        RoundOff: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        BillAddId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class MaterialReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MaterialReceipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialReceiptForm.init)  {
                MaterialReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.LookupEditor;
                var w7 = s.DecimalEditor;
                var w8 = MaterialReceiptItemsEditor;

                Q.initFormType(MaterialReceiptForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'PartyId', w4,
                    'LedgerName', w2,
                    'Address1', w5,
                    'State', w2,
                    'Country', w2,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w6,
                    'ExchRate', w7,
                    'EmployeeId', w3,
                    'ItemDetails', w8,
                    'Remark', w5,
                    'RoundOff', w3,
                    'CompanyId', w3,
                    'BillAddId', w3,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'UserId', w3,
                    'FinancialYearId', w3
                ]);
            }
        }
    }
}
